import React, { useState } from 'react';
import { useRouter, useLocalSearchParams } from 'expo-router';
import { AuthLayout } from '@/components/AuthLayout';
import { LoginForm } from '@/components/forms/LoginForm';
import { TwoFactorForm } from '@/components/forms/TwoFactorForm';
import { ROUTES } from '@/utils/constants';

interface LoginCredentials {
  email: string;
  password: string;
}

export default function LoginScreen() {
  const router = useRouter();
  const params = useLocalSearchParams();
  const [showTwoFactor, setShowTwoFactor] = useState(false);
  const [credentials, setCredentials] = useState<LoginCredentials>({ email: '', password: '' });

  const nextUrl = typeof params.next === 'string' ? params.next : undefined;

  const handleSSOClick = () => {
    router.push(ROUTES.SSO + (nextUrl ? `?next=${nextUrl}` : ''));
  };

  const handleTwoFactorRequired = (email: string, password: string) => {
    setCredentials({ email, password });
    setShowTwoFactor(true);
  };

  const handleBackToLogin = () => {
    setShowTwoFactor(false);
  };

  return (
    <AuthLayout>
      {!showTwoFactor ? (
        <LoginForm 
          onSSOClick={handleSSOClick}
          onTwoFactorRequired={handleTwoFactorRequired}
        />
      ) : (
        <TwoFactorForm 
          onBack={handleBackToLogin}
          email={credentials.email}
          password={credentials.password}
          nextUrl={nextUrl}
        />
      )}
    </AuthLayout>
  );
}
